import { ContractType } from './Contracts';
export var FeedItemType;
(function (FeedItemType) {
    FeedItemType["PROJECT"] = "project";
    //DRAWING = "drawing",
    FeedItemType["FILE"] = "file";
    FeedItemType["SCHEDULE"] = "schedule";
    FeedItemType["RFI"] = "rfi";
    FeedItemType["SUBMITTAL"] = "submittal";
    FeedItemType["SCRAPBOOK"] = "scrapbook";
    FeedItemType["LOG"] = "log";
    //SPECIFICATION = "specification",
    FeedItemType["PHOTO"] = "photo";
    FeedItemType["CONTRACT"] = "contracts";
    FeedItemType["SUBCONTRACT"] = "subcontracts";
    FeedItemType["CHANGE_ORDER"] = "orders";
})(FeedItemType || (FeedItemType = {}));
export var FeedItemSubType;
(function (FeedItemSubType) {
    FeedItemSubType["CREATE"] = "create";
    FeedItemSubType["COMMENT"] = "comment";
    FeedItemSubType["EDIT_COMMENT"] = "edit_comment";
    FeedItemSubType["REMOVED"] = "removed";
    /* all the things that can be updated */
    FeedItemSubType["SUBJECT"] = "subject";
    FeedItemSubType["DESCRIPTION"] = "description";
    FeedItemSubType["PRIORITY"] = "priority";
    FeedItemSubType["PROGRESS"] = "progress";
    FeedItemSubType["STATUS"] = "status";
    /* all the things that can be attached */
    FeedItemSubType["FILE"] = "file";
    FeedItemSubType["PHOTO"] = "photo";
    FeedItemSubType["DRAWING"] = "drawing";
    FeedItemSubType["SPECIFICATION"] = "spec";
    FeedItemSubType["PAGE"] = "page";
    FeedItemSubType["RFI"] = "rfi";
    FeedItemSubType["SUBMITTAL"] = "submittal";
    FeedItemSubType["LOG"] = "log";
    FeedItemSubType["ESTIMATE"] = "estimate";
    /* user related stuff */
    FeedItemSubType["ADD_TEAM"] = "team";
    FeedItemSubType["REQUEST"] = "request";
    FeedItemSubType["INVITE"] = "invite";
    FeedItemSubType["ACCEPT"] = "accept";
    FeedItemSubType["JOINED"] = "joined";
    FeedItemSubType["APPROVE"] = "approve";
    FeedItemSubType["REJECT"] = "reject";
    FeedItemSubType["PROPOSE"] = "propose";
    FeedItemSubType["MARKED"] = "marked";
    /* schedule related stuff */
    FeedItemSubType["VERSION"] = "version";
    FeedItemSubType["SUCCESSOR"] = "successor";
    FeedItemSubType["PREDECESSOR"] = "predecessor";
    //GALLERY = "gallery" // temp file when grouping photos
    // CONTRACT
    FeedItemSubType["CONTRACT_UPDATED"] = "contract_updated";
    FeedItemSubType["CONTRACT_SIGNED"] = "contract_signed";
})(FeedItemSubType || (FeedItemSubType = {}));
export var Frequency;
(function (Frequency) {
    Frequency["HOURLY"] = "hourly";
    Frequency["DAILY"] = "daily";
    Frequency["WEEKLY"] = "weekly";
    Frequency["NEVER"] = "never";
})(Frequency || (Frequency = {}));
